import { rest } from 'msw';
import { makeListResults } from 'test-util/api/response';
import { getEnv } from 'util/getEnv';
import { surveyDetail, surveys } from './fixtures/surveys.fixture';

const domain = 'incentivio-surveys';

const clientsUrl = `${getEnv(
  'REACT_APP_ADMIN_API_URL',
)}/${domain}/clients/:clientId`;

const baseUrl = `${clientsUrl}/surveys`;
const questionsUrl = `${clientsUrl}/questions`;
const exportCsvUrl = `${getEnv(
  'REACT_APP_ADMIN_API_URL',
)}/incentivio-reports/clients/survey/csv`;

export const surveyReportCsv =
  '"Question","Response"\n"How did we do?","Great"\n';

export const listSurveysMock = fn => rest.get(baseUrl, fn);
export const getSurveyMock = fn => rest.get(`${baseUrl}/:surveyId`, fn);
export const createSurveyMock = fn => rest.post(baseUrl, fn);
export const updateSurveyMock = fn => rest.put(`${baseUrl}/:surveyId`, fn);
export const deleteSurveyMock = fn => rest.delete(`${baseUrl}/:surveyId`, fn);
export const createQuestionMock = fn => rest.post(questionsUrl, fn);
export const updateQuestionMock = fn =>
  rest.put(`${questionsUrl}/:questionId`, fn);
export const deleteQuestionMock = fn =>
  rest.delete(`${questionsUrl}/:questionId`, fn);
export const exportSurveyCSVMock = fn => rest.post(exportCsvUrl, fn);

export const handlers = () => [
  listSurveysMock((req, res, ctx) => {
    const name = req.url.searchParams.get('name');
    const filtered = name
      ? surveys.surveys.filter(survey =>
          survey.name.toLowerCase().includes(name.toLowerCase()),
        )
      : surveys.surveys;

    return res(
      ctx.json(
        makeListResults(filtered, req.url.searchParams, {
          listName: 'surveys',
        }),
      ),
    );
  }),
  getSurveyMock((req, res, ctx) =>
    res(ctx.json({ ...surveyDetail, surveyId: req.params.surveyId })),
  ),
  createSurveyMock((_req, res, ctx) =>
    res(ctx.json({ surveyId: 'new-survey-id' })),
  ),
  updateSurveyMock((req, res, ctx) =>
    res(ctx.json({ surveyId: req.params.surveyId })),
  ),
  deleteSurveyMock((req, res, ctx) =>
    res(ctx.json({ surveyId: req.params.surveyId })),
  ),
  createQuestionMock((_req, res, ctx) =>
    res(ctx.json({ questionId: `new-question-${Date.now()}` })),
  ),
  updateQuestionMock((req, res, ctx) =>
    res(ctx.json({ questionId: req.params.questionId })),
  ),
  deleteQuestionMock((req, res, ctx) =>
    res(ctx.json({ questionId: req.params.questionId })),
  ),
  exportSurveyCSVMock((_req, res, ctx) =>
    res(
      ctx.json({
        status: 'DOWNLOADED',
        responseMessage: 'DOWNLOADED',
        data: { REPORT: surveyReportCsv },
      }),
    ),
  ),
];
